export const LOCALE = {
  en: {
    img: 'https://s3.eu-west-2.amazonaws.com/illustrations.jiffy.team/languages/en.png',
    title: 'EN',
  },
  ar: {
    img: 'https://s3.eu-west-2.amazonaws.com/illustrations.jiffy.team/languages/ar.png',
    title: 'AR',
  },
  is: {
    img: 'https://s3.eu-west-2.amazonaws.com/illustrations.jiffy.team/languages/is.png',
    title: 'IS',
  },
  pl: {
    img: 'https://s3.eu-west-2.amazonaws.com/illustrations.jiffy.team/languages/pl.png',
    title: 'PL',
  },
  fr: {
    img: 'https://s3.eu-west-2.amazonaws.com/illustrations.jiffy.team/languages/fr.png',
    title: 'FR',
  },
  ru: {
    img: 'https://s3.eu-west-2.amazonaws.com/illustrations.jiffy.team/languages/ru.png',
    title: 'RU',
    label: 'Русский',
  },
  uz: {
    img: 'https://s3.eu-west-2.amazonaws.com/illustrations.jiffy.team/languages/uz.png',
    title: 'UZ',
    label: "O'zbekcha",
  },
};
